import { QueryClient } from "@tanstack/react-query";
import { PostHog } from "posthog-js";
import { LoaderFunctionArgs } from "react-router";
import { MAX_RESULTS_PER_PAGE } from "~/participant/components/SavedRolesDataTable";
import { getIsUtahParticipant } from "~/participant/utils/getIsUtahParticipant.helpers";
import { getSavedSearchParams } from "~/participant/utils/getSavedSearchParams.helpers";
import { PARTICIPANTS_QUERIES } from "~/shared/api/participants/participants.queries";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";
import { notFound } from "~/shared/util/notFound";
import { getSkip } from "~/shared/util/pagination.helpers";

export async function savedViewLoader(args: LoaderFunctionArgs, queryClient: QueryClient, postHog?: PostHog) {
  const isUtahParticipant = await getIsUtahParticipant(queryClient);
  const searchParams = new URL(args.request.url).searchParams;
  const { term, orderBy, orderDir, page } = getSavedSearchParams(searchParams);
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

  // For now, this feature is only for participants in the Utah program track
  if (!isUtahParticipant) {
    return notFound();
  }

  queryClient.prefetchQuery(
    PARTICIPANTS_QUERIES.savedRolesList(user.id.toFixed(), {
      params: {
        limit: MAX_RESULTS_PER_PAGE,
        skip: getSkip(page, MAX_RESULTS_PER_PAGE),
        term,
        orderBy: orderBy ?? undefined,
        orderDir: orderDir ?? undefined,
      },
    }),
  );

  return null;
}
